import {
    Dashboard,
    MenuBook,
    CloudSync,
    Folder,
    People,
    AdminPanelSettings,
    History,
    Search,
    Settings
} from "@mui/icons-material";

const menu = [

    {
        id: 1,
        title: "Dashboard",
        icon: Dashboard,
        path: "/dashboard"
    },

    {
        id: 2,
        title: "Knowledge",
        icon: MenuBook,
        path: "/knowledge"
    },

    {
        id: 3,
        title: "Google Drive",
        icon: CloudSync,
        path: "/drive"
    },

    {
        id: 4,
        title: "Projects",
        icon: Folder,
        path: "/projects"
    },

    {
        id: 5,
        title: "Users",
        icon: People,
        path: "/users"
    },

    {
        id: 6,
        title: "Roles",
        icon: AdminPanelSettings,
        path: "/roles"
    },

    {
        id: 7,
        title: "Activity Logs",
        icon: History,
        path: "/activity"
    },

    {
        id: 8,
        title: "AI Search",
        icon: Search,
        path: "/search"
    },

    {
        id: 9,
        title: "Settings",
        icon: Settings,
        path: "/settings"
    }

];

export default menu;